import { Component, Input, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'app-fasttrack-quote-dialog',
  templateUrl: './fasttrack-quote-dialog.component.html',
  styleUrls: ['./fasttrack-quote-dialog.component.scss'],
})
export class FasttrackQuoteDialogComponent implements OnInit {
  data
  constructor(private launchDialogService: LaunchDialogService) {}

  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.data = data.data
    })
  }
  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.FASTTRACK_QUOTE,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
